<template>
	<div>
		<a-modal v-show='!ishand' id='supplylists' width='40rem' v-model="visible" on-ok="handleOk1" v-dragModal
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;font-size: 0.9rem;">
					查看詳情
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 38rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;position: relative;">
					<a-form-model ref='form' :model="form" labelAlign='left' layout="inline" :rules='rules'
						hideRequiredMark>
						<a-row style="padding-bottom: 20px;">
							<a-col :span='12'>
								<div style="display:flex;">
									<div class="staff_name">合約號碼 :</div>
									<div class="border_sty">{{form.contract_number}}</div>
								</div>
							</a-col>
							<a-col :span='12'>
								<div style="display:flex;justify-content: right;">
									<div class="staff_name">聯絡名稱 :</div>
									<div class="border_sty">{{form.name}}</div>
								</div>
							</a-col>
						</a-row>
						<a-row style="padding-bottom: 20px;">
							<a-col :span='12'>
								<div style="display:flex;">
									<div class="staff_name">電話號碼 :</div>
									<div class="border_sty">{{form.phone}}</div>
								</div>
							</a-col>
							<a-col :span='12'>
								<div style="display:flex;justify-content: right;">
									<div class="staff_name">電子郵箱 :</div>
									<div class="border_sty">{{form.email}}</div>
								</div>
							</a-col>
						</a-row>
						<a-row style="padding-bottom: 20px;">
							<a-col :span='12'>
								<div style="display:flex;">
									<div class="staff_name">開始日期 :</div>
									<div class="border_sty">{{form.begindate}}</div>
								</div>
							</a-col>
							<a-col :span='12'>
								<div style="display:flex;justify-content: right;">
									<div class="staff_name">完結日期 :</div>
									<div class="border_sty">{{form.enddate}}</div>
								</div>
							</a-col>
						</a-row>
					
						<div style="padding-bottom: 20px;">
							<div style="display:flex;">
								<div class="staff_name" style="flex-shrink: 0;">公司名稱 :</div>
								<div class="border_sty" style="width: 100%;">{{form.contract_name}}</div>
							</div>
						</div>
						<div style="padding-bottom: 10px;">
							<div style="display:flex;">
								<div class="staff_name" style="flex-shrink: 0;">合約內容 :</div>
								<div class="border_sty" style="width: 100%;">{{form.service_type}}</div>
							</div>
						</div>
					
						<!-- <a-form-model-item prop='remark'>
							<div slot='label' v-html='"備&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;註"'
								style="display: inline-block;color: #000000;"></div>
							{{form.remark}}
						</a-form-model-item> -->

					</a-form-model>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['items'],
		data() {
			return {
				ishand: false,
				fourthqty: '',
				visible: true,
				rules: {
					systemservice: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					register_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					expire_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					system_type: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					ip: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					supplier: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				form: {
					"systemservice": "", //服務系統
					"supplier": "", //供應商
					"ip": "", //域名綁定ip
					"register_date": "", //註冊日期
					"expire_date": "", //到期日期
					"system_type": "", //域名類型
					"remark": "", //備註
					revisitLogList: []
				},
			}
		},
		watch: {
			// items: {
			// 	deep: true,
			// 	handler(ev) {}
			// },
		},
		mounted() {
			if (this.items) {
				this.handz()
			}
		},
		methods: {
			disabledDate(current) {
				if (this.form.expire_date) {
					return current && current > new Date(this.form.expire_date)
				} else {
					return false
				}
			},
			disabledDates(current) {
				if (this.form.register_date) {
					return current && current < new Date(this.form.register_date)
				} else {
					return false
				}
			},
			getdata() {

			},
			//获取美国 香港当地时间
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getitem,
					data: {
						"flag":"systemservice",
						 "contraxtid":this.items
					}
				}).then(res => {
					if (res.data) {
						this.form = res.data
						// App.oTool.successT();
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				// this.handz()
			},
			//下单
			handbect(ruleForm) {
				return
				this.$refs[ruleForm].validate(valid => {
					if (valid) {
						this.form.register_date = this.form.register_date._d ? App.oDate.secsTime3(this.form
							.register_date._d) : this.form.register_date;
						this.form.expire_date = this.form.expire_date._d ? App.oDate.secsTime3(this.form
							.expire_date._d) : this.form.expire_date;
						this.form.token = this.$store.state.token;
						this.form.flag = "systemservice";
						this.$ajax({
							method: 'post',
							url: this.$api.newOther,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	#supplylists .ant-modal-header,
	#supplylists .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.mark-file1 {
		position: absolute;
		top: 0;
		left: 0;
		width: 19rem;

		div {
			font-size: 1rem;
			padding: .5rem 1rem;
			background-color: #0c8b97;
			border-radius: 10px 10px 0 0;
			color: #fff;
			text-align: center;
		}
	}

	#supplylists {
		.ant-modal {
			top: 25vh;
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
			color: #000000;
		}

		.mydivs {
			max-height: 11rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;

			.c {
				font-size: .8rem;
			}

			.f {
				display: flex;
				justify-content: space-between;
			}

			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
		.staff_name{
			display: flex;
    		align-items: center;
			color: #000000;
			font-size: 0.75rem;
		}
		.border_sty{
			border: 1px solid #d9d9d9;
   			border-radius: 4px;
			padding: 4px 11px;
			margin-left: 1%;
			width: 70%;
			height: 1.75rem;
			display: flex;
			align-items: center;
			color: #000000;
			font-size: 0.75rem;

		}
	}
</style>
